<template>
  <p>
    {{ message }}
  </p>
</template>

<script>
export default {
  computed: {
    done () {
      return this.$store.getters['settings/dataInit/getAttr']('done')
    },

    message () {
      if (this.done) {
        return 'データは初期化済みです。'
      }
      return 'データの初期化が必要です。'
    }
  }
}
</script>
